import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import closeImg from "../images/close.png";
import triangle from "../images/triangle.svg";
import { addTrailingZeros } from "../component/helpers/common";

function CratesModal(props) {
    const { orderDetails, crates } = props;

    const cratesDetails = orderDetails ? processOrderDetails(orderDetails) : [];

    function processOrderDetails(details) {
        let cratesItems = new Map();

        details.forEach(detail => {
            let crate = crates.find(item => item.ContainerID === detail.ContainerID);
            if (crate) {
                if (cratesItems.has(crate.value)) {
                    cratesItems.get(crate.value).Qty += parseFloat(detail.Qty);
                } else {
                    cratesItems.set(crate.value, {
                        label: crate.ContainerDesc,
                        Qty: parseFloat(detail.Qty),
                        TypeInCode: crate.TypeInCode
                    });
                }
            }
        });
        
        let cratesItemsArray = Array.from(cratesItems.values());

        cratesItemsArray.sort((a, b) => {
            const numA = parseInt(a.TypeInCode);
            const numB = parseInt(b.TypeInCode);

            if (!isNaN(numA) && !isNaN(numB)) {
                return numA - numB;
            } else if (!isNaN(numA)) {
                return -1;
            } else if (!isNaN(numB)) {
                return 1;
            } else {
                return a.TypeInCode.localeCompare(b.TypeInCode);
            }
        });
        return cratesItemsArray;
    }



    return ReactDOM.createPortal(
        <React.Fragment>
            <div
                className={"modal fade " + (props.modal ? "show " : "")}
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={props.modal ? { display: "block" } : { display: "none" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-darkgrey p-2 px-3">
                            <h1
                                className="modal-title fs-16 text-white"
                                id="exampleModalLabel"
                            >
                                Conatiners on Order
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                style={{
                                    backgroundImage: `url(${closeImg})`,
                                    opacity: 1,
                                    padding: "16px",
                                }}
                                onClick={() => props.setModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div>
                                <div className="card-table table-responsive">
                                    <table className="table table-form">
                                        <thead>
                                            <tr>
                                                <td scope="col" className="width-lg-1"></td>
                                                <td scope="col" className="width-lg-16">Conatiner Description</td>
                                                <td scope="col" className="width-lg-4">Qty</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cratesDetails?.map((crate, index) => {
                                                return (<tr key={index + 1} className="custom-space">
                                                    <td valign="middle">
                                                        <img src={triangle} className="indicator" alt="" />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm input-width-100"
                                                            placeholder="Conatiners"
                                                            defaultValue={crate.label}
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm text-end input-width-90"
                                                            placeholder="Qty"
                                                            defaultValue={addTrailingZeros(crate.Qty)}
                                                            readOnly
                                                        />
                                                    </td>


                                                </tr>)
                                            })}

                                        </tbody>
                                    </table>

                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">

                            <div className="col d-flex justify-content-end align-items-end">

                                <button
                                    onClick={() => props.setModal(false)}
                                    className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                                >
                                    Exit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {props.modal ? <div className="modal-backdrop fade show" /> : ""}
        </React.Fragment>,
        document.getElementById("modal-root")
    );
}
export default CratesModal;